import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PageHeader from '../components/PageHeader.jsx';
import ModelTab1 from '../components/StickyOvi.jsx';
import ModelTab2 from '../components/Beetroot.jsx';
import '../styles/fonts.css';
import '../styles/model.css';

const Hardware = () => {
    let SoftwareImg = 'https://static.igem.wiki/teams/5066/global/bgpic.png';

    const [activeTab, setActiveTab] = useState('tab1');
    const [toSection, setTabSection] = useState('')

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const location = useLocation()
    const { tab, to } = location.state || { tab: 'none', to: 'none' };

    useEffect( () => {
        console.log(`tab: ${tab}, section: ${to}`);

        if (tab) {
            if (tab !== 'none') { setActiveTab(tab); }          
        }
   
        if (to) {
            setTimeout(() => {
                setTabSection(to)              
            }, 250);    
        }
    }, [tab, to]);

    return (
        <div>
            <PageHeader img={SoftwareImg} title="Hardware" />
            <div className="mt-2 text-gray-700 px-8 py-4 bg-pink-50 border-2 border-[#C94C67] rounded-lg max-w-4xl mx-auto">
                <p>
					Welcome to our hardware page! We have developed two parts: Sticky Ovitrap and Beetroot peel. The Sticky Ovitrap, which we named the "Beeter Trap," is a device designed to effectively capture and eliminate Aedes mosquitoes. The second component is the Beetroot Peel Attractant, which utilizes beetroot peel powder as an effective and cost-efficient alternative to geosmin for mosquito oviposition. Through several functional assays, we have proved the effectiveness of both parts. We plan to incorporate both elements together with our synthetic biolarvacide to fulfill the “pull and kill” mechanism. Discover our efforts below to learn more!
                </p>
            </div>

            {/* Tab buttons centered */}
            <div className="flex justify-center">
                <div className="border-gray-200">
                    <div className="flex justify-center space-x-4 p-[25px] relative">
                        {/* Tab Buttons */}
                        <button
                            className={`relative py-4 px-4 text-xs md:text-lg transition-colors duration-300 ease-in-out ${activeTab === 'tab1' ? 'text-[#C94C67] border-brown-600' : 'text-gray-600 border-transparent'} border-b-2 hover:border-[#C94C67] focus:bg-[#e2c6cc] rounded-xl border-[#C94C67]`}
                            onClick={() => handleTabClick('tab1')}
                        >
                            Sitcky Ovitrap
                            {/* Arrow */}
                            {activeTab === 'tab1' && (
                                <div className="absolute left-1/2 transform -translate-x-1/2 bottom-[72px]">
                                    <div className="w-0 h-0 border-l-[15px] border-l-transparent border-r-[15px] border-r-transparent border-t-[15px] border-t-[#C94C67]" />
                                </div>
                            )}
                        </button>
                        <button
                            className={`relative py-4 px-4 text-xs md:text-lg transition-colors duration-300 ease-in-out ${activeTab === 'tab2' ? 'text-[#C94C67] border-brown-600' : 'text-gray-600 border-transparent'} border-b-2 hover:border-[#C94C67] focus:bg-[#e2c6cc] rounded-xl border-[#C94C67]`}
                            onClick={() => handleTabClick('tab2')}
                        >
                            Beetroot Peel
                            {/* Arrow */}
                            {activeTab === 'tab2' && (
                                <div className="absolute left-1/2 transform -translate-x-1/2 bottom-[72px]">
                                    <div className="w-0 h-0 border-l-[15px] border-l-transparent border-r-[15px] border-r-transparent border-t-[15px] border-t-[#C94C67]" />
                                </div>
                            )}
                        </button>
                       
                    </div>
                </div>
            </div>

            {/* Tab content */}
            <div className="p-4">
                {activeTab === 'tab1' && <ModelTab1 to={toSection} />}
                {activeTab === 'tab2' && <ModelTab2 to={toSection} />}
            </div>
        </div>
    );
};

export default Hardware;
